import { render, staticRenderFns } from "./base-title.vue?vue&type=template&id=6a4eb1fa&scoped=true"
import script from "./base-title.vue?vue&type=script&lang=js"
export * from "./base-title.vue?vue&type=script&lang=js"
import style0 from "./base-title.vue?vue&type=style&index=0&id=6a4eb1fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4eb1fa",
  null
  
)

export default component.exports